import { useAtomValue, useSetAtom } from 'jotai';
import { useRouter } from 'next/navigation';

import { activeLeadFormAtom } from '@core/Atoms/Leads/ActiveLeadForm.atom';
import { formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { searchParamsAtom } from '@core/Atoms/SearchParams/SearchParams.atom';
import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { currentVehicleIdAtom } from '@core/Atoms/Vehicle/CurrentVehicleId.atom';
import { navigateToCheckout } from '@core/Utils/Navigation/CheckoutNavigation';
import { isVtiVehicle } from '@core/Utils/Vehicle/IsVtiVehicle';
import { isTspVehicle } from '@core/Utils/Vehicle/isTspVehicle';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

import {
  finCalcInteractedWithAtom,
  finCalcInteractedWithStorageAtom,
} from '../Atoms/FinCalcInteractedWith.atom';
import { hasClickedApplyFinanceAtom } from '../Atoms/HasClickedApplyFinance.atom';
import { generateLeadTrackingData } from '../Tracking/FincalcLead.tracking';

export const useNavigateToCheckout = () => {
  const router = useRouter();
  const vehicle = useAtomValue(currentVehicleAtom)!;

  const setClickedApplyFinance = useSetAtom(hasClickedApplyFinanceAtom);
  const setFinCalcInteractedWith = useSetAtom(finCalcInteractedWithAtom);
  const setFinCalcInteractedWithStorage = useSetAtom(finCalcInteractedWithStorageAtom);
  const toggleLeadForm = useSetAtom(activeLeadFormAtom);

  const hasDealerCash =
    isTspVehicle(vehicle?.details?.dataSource) &&
    vehicle.eligibleProducts.includes('DE_DEALER_CASH');
  const hasVtiCash =
    isVtiVehicle(vehicle?.details?.dataSource) && vehicle.eligibleProducts.includes('DE_D2C_CASH');

  const searchParams = useAtomValue(searchParamsAtom);
  const userId = useAtomValue(userIdAtom);
  const formState = useAtomValue(formStateAtom);
  const listingId = useAtomValue(currentVehicleIdAtom);
  const leadFormId = 'finance_quote';

  const handleNavigateToCheckoutClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setClickedApplyFinance(true);
    setFinCalcInteractedWithStorage(true);

    if (!navigateToCheckout(router, vehicle, hasDealerCash, hasVtiCash)) {
      setFinCalcInteractedWith(true);
      const {
        leadStart: { event, context },
      } = generateLeadTrackingData({
        searchParams,
        userId,
        formState,
        leadFormId,
        listingId,
        vehicle,
      });
      trackCustomEvent({ event, context });
      toggleLeadForm('message-dealer-finance');
    }
  };

  return { handleNavigateToCheckoutClick };
};
